import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import ExperienceCard from './experienceCard';
import BaseBlock from "./BaseBlock";

import GrowOnScroll from './animation/GrowAnimation';


function ExperienceList(props) {
  const experiences = props.data.experiences;

  const experiencesItemlist = experiences.map((experience, index) => {
    return (
      <Grid item key={index} xs={12} sm={12} md={6}>
        <GrowOnScroll
          children={
            <ExperienceCard key={index} experience={experience}>
            </ExperienceCard>
          }
        >
        </GrowOnScroll>
      </Grid>
    )
  });

  return (
    <Grid container spacing={2}>
      {experiencesItemlist}
    </Grid>
  )
}

function ExperienceBlock(props) {
  return (
    <BaseBlock
      blockTitle="EXPERIENCE"
      blockSubtitle="Career / Education"
      blockContent={<ExperienceList data={props.data}></ExperienceList>}
      blockTheme='dark'
    >
    </BaseBlock>
  )
}

const Experience = forwardRef((props, ref) => {
  return (
    <Box ref={ref}>
      <ExperienceBlock data={props.data}>
      </ExperienceBlock>
    </Box>
  )
});

export default Experience;